import React from 'react';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

export default function OrderDetailsPaymentsDataTable({ payments }) {
    return (
        <TableContainer component={Card} sx={{ elevation: 0, border: '1px solid #e0e0e0', borderRadius: 3, boxShadow: 'none' }}>
            <Table sx={{ minWidth: 700 }}>
                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                    <TableRow>
                        <TableCell><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Fecha</Typography></TableCell>
                        <TableCell><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Método</Typography></TableCell>
                        <TableCell><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Banco</Typography></TableCell>
                        <TableCell><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Cuenta</Typography></TableCell>
                        <TableCell><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Referencia</Typography></TableCell>
                        <TableCell align='right'><Typography variant="caption" fontWeight="bold" color="text.secondary" textTransform="uppercase">Monto</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {payments.map((item, index) => (
                        <TableRow key={index} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell>
                                <Typography variant="body2" color="text.secondary">{item.payment_date}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2" fontWeight="600">{item.payment_method}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2" color="text.secondary">{item.bank_name || '-'}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2" color="text.secondary">{item.account_number || '-'}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2" fontWeight="bold" sx={{ fontFamily: 'monospace', color: '#555' }}>
                                    {item.reference || 'N/A'}
                                </Typography>
                            </TableCell>
                            <TableCell align='right'>
                                <Typography variant="body2" fontWeight="bold" color="#2e7d32">
                                    + ${item.amount}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}